import type React from 'react';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { SubpageLayout } from '../../components/layouts/subpage-layout';
import { NewPagination } from '../../components/new-pagination/new-pagination';
import { SimpleCompanyCardGrid } from '../../components/simple-company-card-grid/simple-company-card-grid';
import { useMostVisitedCompanies } from '../../hooks/use-most-visited-companies';
import { usePagination } from '../../hooks/use-pagination';
import { useTrackPage } from '../../hooks/use-track-page';
import { createSimpleCompanies } from '../../models/simple-company';
import { pagesTrackingName } from '../../utils/tracking';

const LIMIT = 78;

export const LOMostVisitedCompanies: React.FC = () => {
  const intl = useIntl();
  const { activePage } = usePagination();
  const [totalCompanies, setTotalCompanies] = useState(0);

  const { data, loading } = useMostVisitedCompanies({
    limit: LIMIT,
    offset: LIMIT * (activePage - 1),
  });

  useEffect(() => {
    const total = data?.mostVisitedCompanies?.total ?? 0;

    if (!loading && totalCompanies !== total) {
      setTotalCompanies(total);
    }
  }, [loading]);

  const mostVisitedCompanies = data?.mostVisitedCompanies?.collection ?? [];
  // @ts-expect-error ignore null errors from graphql
  const simpleCompanyCards = createSimpleCompanies(mostVisitedCompanies);

  useTrackPage({ pageName: pagesTrackingName.mostVisited });

  return (
    <SubpageLayout
      headerText={intl.$t({ id: 'CP_100_MOST_CLICKED_COMPANIES_HEADLINE' })}
      description={intl.$t({ id: 'CP_100_MOST_CLICKED_COMPANIES_TEXT' })}
    >
      {simpleCompanyCards && (
        <>
          {loading ? (
            <SimpleCompanyCardGrid.Skeleton amountOfCards={LIMIT} />
          ) : (
            <SimpleCompanyCardGrid items={simpleCompanyCards} />
          )}

          <NewPagination
            currentPage={activePage}
            perPage={LIMIT}
            limitPages={4}
            total={totalCompanies}
          />
        </>
      )}
    </SubpageLayout>
  );
};
